import React, { useState } from 'react';

import Header from '../../Header'
import CreateNewUser from '../../forms/CreateUser'

import './style.css';
import ListUsers from '../../forms/ListUsers';
import CommercialAccounts from '../../forms/CommercialAccounts';
import { useUser } from '../../../contexts/userContext';

function UsersPage() {
  const [view, setView] = useState('users');

  const { user } = useUser(); // Acesso ao estado global do usuário

  const { openCloseCreateUser, openModalCreateUser } = useUser();

  return (
    <div className='users-page-container'>
      <Header />
      <div className='tools-container users-admin-tools'>
        <button onClick={() => setView('users')} className='admin-menu-button'>Usuários</button>
        {Number(user?.access_level) === 8 && <button onClick={() => setView('companies')} className='admin-menu-button'>Empresas comerciais</button>}
      </div>
      <div className='users-body-container'>
        {view === 'users' ? <ListUsers /> : <CommercialAccounts />}
        {openCloseCreateUser && (
          <CreateNewUser />
        )}

      </div>

      {view === 'users' && <button className='users-page-floating-button' onClick={openModalCreateUser}>+</button>}


    </div>

  );
}

export default UsersPage;
